import React, { useEffect, useState } from "react";
import { DetailsInfoContainer } from "../../styled/pickup";
import { orderType } from "../../function/store";
import { useSelector } from "react-redux";
import axios from "axios";
import { IoIosNotificationsOutline } from "react-icons/io";
import OrderInfo from "../../common/orderInfo";
import moment from "moment";
import { FaSortDown, FaSortUp } from "react-icons/fa";
import { BsCaretDownFill, BsCaretUpFill } from "react-icons/bs";

const DetailsInfo = ({
  selected,
  openModal,
  rejectOrder,
  acceptOrder,
  updateOrder,
  setSelected,
  completedOrder,
  cancelOrder,
}) => {
  const user = useSelector((state) => state?.user?.data[0]);
  const [pickupBy, setPickupBy] = useState(10);

  useEffect(() => {
    setPickupBy(10);
  }, [selected]);

  const editPickupBy = (type = false) => {
    setPickupBy((time) => (type ? time + 10 : Math.max(time - 10, 10)));
  };

  const renderActions = (viewType) => {
    switch (viewType) {
      case "CANCELLED":
        return null;

      case "PICKUP":
        return (
          <div className="time">
            <span>주문시간: {moment(selected.createdAt).format("a h시m분")}</span>
            <span>완료시간: {moment(selected.updatedAt).format("a h시m분")}</span>
          </div>
        );
      case "READY":
      case "COMPLETED":
      case "CONFIRMED":
        return (
          <div className="actions">
            {/* <button onClick={() => setSelected(false)}>취소</button> */}
            <button
              className="notify"
              onClick={() =>
                openModal({
                  type: "confirmation",
                  title: "상품 준비 완료",
                  message: ["상품 준비 완료 알림을 고객님께 보내시겠습니까?"],
                  handleConfirm: () => completedOrder(selected.id),
                })
              }>
              <span className="icon">
                <IoIosNotificationsOutline />
              </span>
              상품 준비 완료 알림
            </button>
            <button
              onClick={() =>
                openModal({
                  type: "confirmation",
                  title: "픽업 완료",
                  message: ["해당 주문을 완료하시겠습니까?"],
                  handleConfirm: () => updateOrder(selected.id),
                })
              }>
              픽업완료
            </button>
          </div>
        );

      case "CANCEL_REQUESTED":
        return (
          <div className="actions">
            <button
              onClick={() =>
                openModal({
                  type: "confirmation",
                  title: "주문 취소 거절",
                  message: ["주문 취소 요청을 거절하시겠습니까?"],
                  handleConfirm: () => cancelOrder(selected.id, false),
                })
              }>
              거절
            </button>
            <button
              className="cancel"
              onClick={() =>
                openModal({
                  type: "confirmation",
                  title: "주문 취소 수락",
                  message: ["주문 취소 요청을 수락하시겠습니까?"],
                  handleConfirm: () => cancelOrder(selected.id, true),
                })
              }>
              수락
            </button>
          </div>
        );

      case "PENDING":
        return (
          <div className="actions">
            <button onClick={() => rejectOrder(selected)}>거절</button>
            <div className="stepper">
              <button onClick={() => editPickupBy()}>
                <BsCaretDownFill />
              </button>
              <span className="current">{pickupBy}분</span>
              <button onClick={() => editPickupBy(true)}>
                <BsCaretUpFill />
              </button>
            </div>
            <button
              onClick={() =>
                openModal({
                  type: "confirmation",
                  title: "주문 수락",
                  message: ["주문을 수락하시겠습니까?"],
                  handleConfirm: () => acceptOrder(selected.id, pickupBy),
                })
              }>
              수락
            </button>
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <DetailsInfoContainer className={selected?.status}>
      {selected ? (
        <>
          <OrderInfo selected={selected} />
          {renderActions(selected.status)}
        </>
      ) : (
        <></>
      )}
    </DetailsInfoContainer>
  );
};

export default DetailsInfo;
